<dx-popup [showTitle]="true" width="70vw" height="70vh" visible="true" title="Dettaglio Log Azioni"
  (onHiding)="onPopupCloseClick()">

  <div class="row">
    <div class="col-12 col-md-6 col-lg-3">
      Utente: <b>{{rigaDettaglio?.logAzioni?.idUtente}} - {{rigaDettaglio?.utente}}</b>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      Tabella: <b>{{rigaDettaglio?.logAzioni?.tabella}}</b>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      Chiave: <b>{{rigaDettaglio?.logAzioni?.chiaveTabella}}</b>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-3">
      Azione: <b>{{rigaDettaglio?.logAzioni?.azione}}</b>
    </div>
    <div class="col-12 col-md-6 col-lg-3">
      Data ora: <b>{{rigaDettaglio?.logAzioni?.dataOra | date: 'dd/MM/yyyy HH:mm:ss'}}</b>
    </div>
  </div>
  <hr>
    <div class="row">
      @if (datiObj) {
        <div class="col-12 col-md-6">
          <h6>Dati</h6>
          <ul>
            @for (entry of (datiObj | keys); track entry) {
              <li>
                {{entry.key}}: <b>{{entry.value}}</b>
              </li>
            }
          </ul>
        </div>
      }
      @if (dettaglioObj) {
        <div class="col-12 col-md-6">
          <h6>Dettagli</h6>
          <ul>
            @for (entry of (dettaglioObj | keys); track entry) {
              <li>
                {{entry.key}}: <b>{{entry.value}}</b>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </dx-popup>
